// src/components/ChangePassword.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";

const ChangePassword = ({ user, setUser }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (newPassword !== confirmNewPassword) {
            setError("New passwords do not match");
            return;
        }

        setLoading(true);

        try {
            // Backend returns new JWT after password change
            const res = await axiosInstance.post("/change-password", {
                currentPassword,
                newPassword,
            });

            const { token: newToken } = res.data;

            // Save new JWT in localStorage
            localStorage.setItem("jwtToken", newToken);
            axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;

            // Decode new JWT
            const decodedToken = JSON.parse(atob(newToken.split(".")[1]));

            // Update user state
            if (setUser) {
                setUser({
                    name: decodedToken.name,
                    role: decodedToken.role,
                    id: decodedToken.id,
                    isNewUser: decodedToken.isNewUser,
                });
            }

            // Navigate to dashboard
            navigate("/dashboard");
        } catch (err) {
            setError(err.response?.data?.message || "Failed to change password");
        } finally {
            setLoading(false);
        }
    };

  return (
    <div className="page-container" style={{ maxWidth: 400, margin: "4rem auto", padding: "2rem", boxShadow: "0 4px 12px rgba(0,0,0,0.1)", borderRadius: 8 }}>
      <h2>Change Password</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "1rem" }}>
          <input
            type="password"
            placeholder="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={6}
            style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
            minLength={6}
            style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
          />
        </div>

        {error && <div style={{ color: "red", marginBottom: "1rem" }}>{error}</div>}

        <button type="submit-btn" disabled={loading} style={{ width: "100%", padding: "0.75rem", fontSize: "1rem", cursor: loading ? "not-allowed" : "pointer" }}>
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
